(function () {
  'use strict';

  // Forged carbon swatch (decorative canvas)
  function drawForged(cv) {
    var w = cv.clientWidth || 400, h = 170, r = window.devicePixelRatio || 1;
    cv.width = w * r; cv.height = h * r;
    var c = cv.getContext('2d'); if (!c) return;
    c.setTransform(r, 0, 0, r, 0, 0);
    c.fillStyle = '#07090d'; c.fillRect(0, 0, w, h);
    var s = 7;
    function rnd() { s = (s * 16807) % 2147483647; return s / 2147483647; }
    for (var i = 0; i < 95; i++) {
      var x = rnd() * w, y = rnd() * h, n = 3 + Math.floor(rnd() * 3), R = 14 + rnd() * 34, a = rnd() * 6.28;
      c.beginPath();
      for (var k = 0; k < n; k++) {
        var t = a + k * 6.28 / n + rnd() * 0.7, rr = R * (0.5 + rnd() * 0.7);
        c.lineTo(x + Math.cos(t) * rr, y + Math.sin(t) * rr);
      }
      c.closePath();
      var g = 18 + Math.floor(rnd() * 46);
      c.fillStyle = 'rgba(' + g + ',' + (g + 4) + ',' + (g + 14) + ',' + (0.5 + rnd() * 0.5) + ')';
      c.fill();
      c.strokeStyle = 'rgba(120,140,180,' + (rnd() * 0.12) + ')';
      c.stroke();
    }
  }
  function drawAll() {
    document.querySelectorAll('canvas[data-forged]').forEach(drawForged);
  }
  var timer;
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(drawAll, 150); });
  document.addEventListener('shopify:section:load', drawAll);
  drawAll();

  // Product page: photo thumbnails and variant price
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pp-thumb]');
    if (!btn) return;
    var scope = btn.closest('[data-product-section]');
    var img = scope && scope.querySelector('[data-pp-main] img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = btn.getAttribute('data-src');
    img.alt = btn.getAttribute('data-alt') || '';
    scope.querySelectorAll('[data-pp-thumb]').forEach(function (b) { b.removeAttribute('aria-current'); });
    btn.setAttribute('aria-current', 'true');
  });

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('[data-pp-variant]')) return;
    var scope = sel.closest('[data-product-section]');
    var opt = sel.options[sel.selectedIndex];
    var price = scope.querySelector('[data-pp-price]');
    var was = scope.querySelector('[data-pp-was]');
    var add = scope.querySelector('[data-pp-add]');
    var label = scope.querySelector('[data-pp-add-label]');
    if (price && opt) price.textContent = opt.getAttribute('data-price');
    if (was) was.hidden = true;
    var ok = opt && opt.getAttribute('data-available') === 'true';
    if (add) add.disabled = !ok;
    if (label) label.textContent = ok ? 'Add to cart' : 'Sold out';
  });
})();
